import { render, staticRenderFns } from "./EmployeeReferralSystem.vue?vue&type=template&id=17779f3a&scoped=true&"
import script from "./EmployeeReferralSystem.vue?vue&type=script&lang=js&"
export * from "./EmployeeReferralSystem.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeReferralSystem.vue?vue&type=style&index=0&id=17779f3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17779f3a",
  null
  
)

export default component.exports